import { useAppSelector } from 'dux/app/hooks';

import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import Spacer from 'Components/Spacer';
import { TextImage } from 'Components/TextImage';
import { Typography } from 'Components/Typography';

import { productsCategories, productsSubCategories } from 'constants/products';

import { Faq } from 'Blocks/Faq';
import { Ticker } from 'Blocks/Ticker';
import Values from 'Blocks/Values';
import ProductVariantHero from '../Blocks/ProductVariantHero';
import ProductWithVariantsHero from '../Blocks/ProductWithVariantsHero';

import ScrollTracker from 'Containers/ScrollTracker';

import { LegacyBaseScene } from 'Scenes/LegacyBaseScene';

import useResponsiveVariant from 'utils/useResponsiveVariant';

import { getBrushProductPageContent } from 'dux/products/selectors';
import { useTrackProductViewed } from 'dux/products/hooks';

const StyledTypo = styled(Typography)`
  color: ${theme.colors.primary[400]};
`;

const MakeItYoursContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  ${legacyTheme.breakpoints.up('md')} {
    height: 45rem;
  }
`;

const BrushProductDetails = () => {
  const { isDesktop } = useResponsiveVariant();
  const content = useAppSelector(getBrushProductPageContent);

  const { faq, heroModule, makeItYours, ticker, variantsHero, values } = content;

  useTrackProductViewed({
    category: productsCategories.OTHERS,
    subcategory: productsSubCategories.TOOLS,
    product: heroModule.product,
  });

  return (
    <LegacyBaseScene footer FooterProps={{ hideCTA: true }} header justifyContent="start">
      <ScrollTracker>
        <ProductWithVariantsHero content={heroModule} />
        <Ticker color={theme.colors.primary[400]} content={ticker} hasBorder showDash={false} />
        {variantsHero.map(variant => (
          <ProductVariantHero key={variant.slug} content={variant} />
        ))}
        <Values content={values} />
        <TextImage
          /* WARN: Exceptionally let a hexcode color for the sake of visual coherence with the section's images background */
          backgroundColor="#b1a49c"
          contentAlign="left"
          contentAlignMob="left"
          imageDesktop={makeItYours.image.desktop}
          imageMobile={makeItYours.image.mobile}
          imageMode={isDesktop ? 'contain' : 'cover'}
        >
          <MakeItYoursContainer>
            <StyledTypo variant="h1">{makeItYours.title}</StyledTypo>
            <Spacer size={24} />
            <StyledTypo variant="p1">{makeItYours.subTitle}</StyledTypo>
          </MakeItYoursContainer>
        </TextImage>
        <Faq
          backgroundColor="vert"
          questions={faq.questions}
          shouldGenerateJsonld
          title={faq.title}
          variant="dark"
        />
      </ScrollTracker>
    </LegacyBaseScene>
  );
};

export default BrushProductDetails;
